import React from 'react';
export default function PageLoadFailure() {
  return (
      <main className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-950 px-6">
        <section role="alert" className="max-w-lg text-center text-gray-900 dark:text-gray-100">
          <h1 className="text-2xl font-semibold">This page couldn’t load</h1>
          <p className="mt-3">The page may have been updated, or your connection may have been interrupted. Refresh to try again.</p>
          <button type="button" onClick={() => window.location.reload()} className="mt-6 rounded-lg bg-blue-600 px-5 py-3 font-medium text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Refresh page</button>
          <p className="mt-4"><a className="underline" href="/marketplace">Go to marketplace</a></p>
        </section>
      </main>
  );
}
